// extracted by mini-css-extract-plugin
export var loadingSpinner = "_18-0";
export var spinnerContainer = "_18-1";